import { Direction } from '../../constants';

export const DEBOUNCE_DELAY = 50;
export const EDGE_DETECTION_INACCURACY_PX = 1;
export const SCROLL_VIEW_ARROWS_LABEL_HORIZONTAL_END = 'Scroll right';
export const SCROLL_VIEW_ARROWS_LABEL_HORIZONTAL_START = 'Scroll left';
export const SCROLL_VIEW_ARROWS_LABEL_VERTICAL_END = 'Scroll down';
export const SCROLL_VIEW_ARROWS_LABEL_VERTICAL_START = 'Scroll up';
export const SCROLL_VIEW_DEFAULT_DIRECTION = Direction.VERTICAL;
export const SCROLL_VIEW_DEFAULT_OVERFLOW_DECORATOR = 'shadows';
